import React from "react";
import "./infoBox.scss";

type InfoBoxProps = {
    sede: any;
    zoom: number;
    tituloEnlace?: string;
};

export default function InfoBox({ sede, zoom, tituloEnlace }: InfoBoxProps) {
    const handleClick = async () => {
        if (sede.slug.includes("comfama.com")) {
            window.location.href = sede.slug.replace(
                "https://www.comfama.com",
                ""
            );
        } else {
            window.open(sede.slug, "_blank");
        }
    };

    const getContentByTitleLink = () => {
        if (!tituloEnlace) {
            return zoom === 10 ? (
                <div className="m-infobox__container__info__link">
                    <p
                        className="m-infobox__container__info__link--decoration"
                        onClick={handleClick}
                    >
                        ¿Cómo llegar?
                    </p>
                </div>
            ) : <></>;
        } else if (tituloEnlace !== "") {
            return <div className="m-infobox__container__info__link">
                <p
                    className="m-infobox__container__info__link--decoration"
                    onClick={handleClick}
                >
                    {tituloEnlace}
                </p>
            </div>;
        }
    }

    return (
        <div className="m-infobox__container">
            <div
                className="m-infobox__container__img"
                style={{ backgroundImage: `url(${sede.image[0].file.url})` }}
            ></div>
            <div className="m-infobox__container__info">
                <div className="m-infobox__container__info__name">
                    {sede.name}
                </div>
                {getContentByTitleLink()}
            </div>
        </div>
    );
}
